import { useRef } from "react";
import { Upload, FileText, X } from "lucide-react";
import { Label } from "@/components/ui/label";

const MAX_BYTES = 5 * 1024 * 1024;
const ALLOWED_EXT = ["pdf", "doc", "docx"];
const formatSize = (b) => (b >= 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(2)} MB` : `${Math.round(b / 1024)} KB`);

export const CvUploadField = ({ file, onChange, onError, error }) => {
  const fileRef = useRef(null);

  const pick = (f) => {
    if (!f) return;
    const ext = f.name.split(".").pop().toLowerCase();
    if (!ALLOWED_EXT.includes(ext)) return onError("Formato non valido: sono accettati solo PDF o Word (.doc, .docx)");
    if (f.size > MAX_BYTES) return onError("Il file supera la dimensione massima di 5 MB");
    onChange(f);
  };

  const clear = () => {
    onChange(null);
    if (fileRef.current) fileRef.current.value = "";
  };

  return (
    <div className="sm:col-span-2">
      <Label>Curriculum Vitae (PDF o Word, max 5 MB) *</Label>
      <input
        ref={fileRef}
        type="file"
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        className="hidden"
        data-testid="app-input-cv"
        onChange={(e) => pick(e.target.files?.[0])}
      />
      {file ? (
        <div className="mt-2 flex items-center justify-between gap-4 border border-gold/40 bg-gold/10 px-4 py-3" data-testid="app-cv-selected">
          <div className="flex min-w-0 items-center gap-3">
            <FileText className="h-5 w-5 shrink-0 text-gold-dark" />
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-navy">{file.name}</p>
              <p className="text-xs text-slate-500">{formatSize(file.size)}</p>
            </div>
          </div>
          <button type="button" onClick={clear} className="p-1 text-slate-500 hover:text-red-600" data-testid="app-cv-remove" aria-label="Rimuovi file">
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => { e.preventDefault(); pick(e.dataTransfer.files?.[0]); }}
          data-testid="app-cv-dropzone"
          className="mt-2 flex w-full flex-col items-center justify-center gap-2 border border-dashed border-navy/25 bg-pearl/60 px-4 py-8 text-center transition-colors hover:border-gold hover:bg-gold/5"
        >
          <Upload className="h-6 w-6 text-gold-dark" />
          <span className="text-sm font-medium text-navy">Trascina qui il tuo CV o clicca per selezionarlo</span>
          <span className="text-xs text-slate-500">Formati accettati: PDF, DOC, DOCX — dimensione massima 5 MB</span>
        </button>
      )}
      {error && <p className="mt-1 text-xs text-red-600" data-testid="app-error-cv">{error}</p>}
    </div>
  );
};
